import React from "react";
import { Link } from "react-router-dom";

export default function DocumentButton(props) {
  return (
    <div>
      {localStorage.getItem("companyStatusId") >= 5 ? (
        <Link
          to={`/employee/${props.id}`}
          id={props.id}
          title={props.name}
          className="btn btn-rounded btn-outline-info"
        >
          <i className="fa fa-files-o" />
          Documentos
        </Link>
      ) : null}
    </div>
  );
}
